import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { determineDeclension as declension, emptyArr } from '@beef/utils';
import { AccumUnit, UNIT_LOCALE } from "../types/accumulators";
import { MAX_UNITS_LENGTH } from "../constants/accumulators";
import { TARIFF_TEXTS } from "../constants/tariff";
var hasDefined = function hasDefined(value) {
  return typeof value === 'number' && !Number.isNaN(value);
};
var getInternetValueAndUnit = function getInternetValueAndUnit(value) {
  if (value < MAX_UNITS_LENGTH.GIGABYTE) {
    return {
      rest: (value / MAX_UNITS_LENGTH.MEGABYTE).toFixed(1),
      unit: UNIT_LOCALE.GIGABYTE
    };
  }
  return {
    rest: (value / MAX_UNITS_LENGTH.GIGABYTE).toFixed(1),
    unit: UNIT_LOCALE.TERABYTE
  };
};
var formatDataAsTb = function formatDataAsTb(_ref) {
  var rest = _ref.rest,
    data = _ref.data,
    size = _ref.size;
  var updateFields = {};
  data.displayUnit = UNIT_LOCALE.TERABYTE;
  var hasSize = hasDefined(size);
  var hasRest = hasDefined(rest);
  if (hasRest) {
    var newRest = Number(getInternetValueAndUnit(rest).rest);
    data.rest = newRest;
    data.displayUnit = newRest > 0 ? getInternetValueAndUnit(rest).unit : '';
  }
  if (hasSize) {
    data.size = undefined;
    if (hasRest && rest === size) {
      data.sizeText = 'доп пакет';
    } else {
      data.sizeText = "\u0438\u0437 ".concat(Number((size / MAX_UNITS_LENGTH.GIGABYTE).toFixed(2)), " ").concat(UNIT_LOCALE.TERABYTE, " \u0434\u043E\u043F");
    }
  }
  return _objectSpread(_objectSpread({}, data), updateFields);
};
var formatDataAsGb = function formatDataAsGb(_ref2) {
  var rest = _ref2.rest,
    data = _ref2.data,
    size = _ref2.size,
    baseRest = _ref2.baseRest;
  var updateFields = {};
  data.displayUnit = UNIT_LOCALE.GIGABYTE;
  if (hasDefined(rest)) {
    data.rest = Number((rest / MAX_UNITS_LENGTH.MEGABYTE).toFixed(2));
  }
  if (hasDefined(size)) {
    data.size = Number((size / MAX_UNITS_LENGTH.MEGABYTE).toFixed(2));
  }
  if (hasDefined(baseRest)) {
    data.baseRest = baseRest;
  }
  return _objectSpread(_objectSpread({}, data), updateFields);
};
var formatDataAsMb = function formatDataAsMb(_ref3) {
  var rest = _ref3.rest,
    data = _ref3.data,
    size = _ref3.size;
  var updateFields = {};
  data.displayUnit = UNIT_LOCALE.MEGABYTE;
  data.rest = Number((rest / MAX_UNITS_LENGTH.KBYTE).toFixed(2));
  if (size) {
    data.size = Number((size / MAX_UNITS_LENGTH.KBYTE).toFixed(2));
  }
  return _objectSpread(_objectSpread({}, data), updateFields);
};
var isWithinKbRange = function isWithinKbRange(value) {
  return value < MAX_UNITS_LENGTH.KBYTE;
};
var isWithinMbRange = function isWithinMbRange(value) {
  return value > MAX_UNITS_LENGTH.KBYTE && value < MAX_UNITS_LENGTH.MEGABYTE;
};
var isWithinGbRange = function isWithinGbRange(value) {
  return value >= MAX_UNITS_LENGTH.MEGABYTE;
};
var formatForRestOnly = function formatForRestOnly(_ref4) {
  var rest = _ref4.rest,
    data = _ref4.data;
  var updateFields = {};
  if (rest === 0) {
    updateFields.rest = rest;
    updateFields.displayUnit = UNIT_LOCALE.GIGABYTE;
    return _objectSpread(_objectSpread({}, data), updateFields);
  }
  if (isWithinKbRange(rest)) {
    data.rest = rest;
    data.displayUnit = UNIT_LOCALE.KBYTE;
    return _objectSpread(_objectSpread({}, data), updateFields);
  }
  if (isWithinMbRange(rest)) {
    formatDataAsMb({
      rest: rest,
      data: data
    });
    return _objectSpread(_objectSpread({}, data), updateFields);
  }
  if (isWithinGbRange(rest)) {
    formatDataAsGb({
      rest: rest,
      data: data
    });
    return _objectSpread(_objectSpread({}, data), updateFields);
  }
  return _objectSpread(_objectSpread({}, data), updateFields);
};
export var formatInternetAccumulator = function formatInternetAccumulator(rest, size, baseRest, isGiftBucket) {
  var data = {
    rest: rest
  };
  if (isGiftBucket) {
    return formatDataAsTb({
      rest: rest,
      size: size,
      data: data
    });
  }
  if (hasDefined(size)) {
    if (size === 0 || size < rest) {
      return formatDataAsGb({
        rest: rest,
        size: size,
        data: data
      });
    }
    if (size >= rest && isWithinMbRange(size)) {
      return formatDataAsMb({
        rest: rest,
        size: size,
        data: data
      });
    }
    return formatDataAsGb({
      rest: rest,
      size: size,
      data: data
    });
  }
  if (hasDefined(baseRest) && rest === 0) {
    return formatDataAsGb({
      baseRest: baseRest,
      data: data
    });
  }
  if (hasDefined(baseRest) && rest > 0) {
    return formatForRestOnly({
      rest: rest,
      data: data
    });
  }
  return formatForRestOnly({
    rest: rest,
    data: data
  });
};
export var formatTimeAccumulator = function formatTimeAccumulator(rest, size, baseRest) {
  var data = {
    rest: rest
  };
  if (rest >= MAX_UNITS_LENGTH.SECONDS || rest === 0) {
    data.rest = Math.floor(rest / 60);
    data.displayUnit = declension(['минута', 'минуты', 'минут'], data.rest);
  } else if (rest < MAX_UNITS_LENGTH.SECONDS && rest !== 0) {
    data.rest = Number(rest);
    data.displayUnit = declension(['секунда', 'секунды', 'секунд'], data.rest);
  }
  if (size && hasDefined(size)) {
    data.size = Math.floor(size / 60);
    data.rest = rest < 60 ? rest / 100 : Math.floor(rest / 60);
    data.displayUnit = declension(['минута', 'минуты', 'минут'], data.size);
  }
  if (hasDefined(baseRest) && rest === 0) {
    data.baseRest = baseRest;
    data.displayUnit = 'минута';
  }
  return data;
};
var normalizeUnits = function normalizeUnits(_ref5) {
  var unit = _ref5.unit,
    rest = _ref5.rest,
    size = _ref5.size,
    baseRest = _ref5.baseRest,
    isGiftBucket = _ref5.isGiftBucket;
  switch (unit) {
    case AccumUnit.KBYTE:
      {
        return formatInternetAccumulator(rest, size, baseRest, isGiftBucket);
      }
    case AccumUnit.SECONDS:
      {
        return formatTimeAccumulator(rest, size, baseRest);
      }
    case AccumUnit.SMS:
      {
        return {
          displayUnit: 'смс'
        };
      }
    default:
      {
        return {
          displayUnit: unit,
          rest: rest
        };
      }
  }
};
export var convertAccumulators = function convertAccumulators(acc) {
  if (!acc || !acc.length) return emptyArr;
  return acc.map(function (item) {
    return _objectSpread(_objectSpread({}, item), normalizeUnits(item));
  });
};
export var getNextBillingInfo = function getNextBillingInfo(nextBillingDate, additionalBillingInfo) {
  var additionalText = additionalBillingInfo ? ", ".concat(additionalBillingInfo) : '';
  return "".concat(TARIFF_TEXTS.defaultNextBillingDateText, " ").concat(nextBillingDate).concat(additionalText);
};